module.exports = "<div class=\"panel-body pX-10\">\n    <form class=\"col-sm-12\" id=\"form\" name=\"form\">\n        <p class=\"text-center\">\n            {{message}}\n        </p>\n    </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/blockpassword/blockpassword.template.html
// module id = 799
// module chunks = 0